import { render, staticRenderFns } from "./VesselList.vue?vue&type=template&id=1d2079ff&scoped=true"
import script from "./VesselList.vue?vue&type=script&lang=js"
export * from "./VesselList.vue?vue&type=script&lang=js"
import style0 from "./VesselList.vue?vue&type=style&index=0&id=1d2079ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2079ff",
  null
  
)

export default component.exports